import { render, staticRenderFns } from "./leadsDashboardReferralSettings.vue?vue&type=template&id=3b46426c&scoped=true"
import script from "./leadsDashboardReferralSettings.vue?vue&type=script&lang=js"
export * from "./leadsDashboardReferralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b46426c",
  null
  
)

export default component.exports